// ControlProgressBarFactory.js
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import ProgressBarControlView from 'advanced-visuals/ProgressBarControlView.js';

//=============================================================================
//
// Creates a progress bar control, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Lou Mauget, December 8, 2015
//
//=============================================================================
class ControlProgressBarFactory extends BaseVisualControlFactory {
    constructor () {
        super();
    }

    createView( factoryKey, pos ) {
        const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        attributes.styleColorBar = '#CCCCCC';
        attributes.borderColor = '#CCCCCC';
        attributes.visible = true;
        attributes.text = '0%';
        attributes.value = '0';
        attributes.maxValue = '100';
        attributes.showLabel = true;
        attributes.label = '%1%';
        attributes.barColor = '#F89B3C';
		attributes.minWidth = 22;
        attributes.lowestHeight = 15;
        this.resolveForInitialMinHeight(attributes);
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.translateProps = [
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"}
        ];

        return new ProgressBarControlView( {
            model: new ControlModel( attributes ),
            el: $(constants.FORM_ID),
            pos: pos,
            factoryKey: factoryKey,
            id: attributes.id } );
    }

}

const controlProgressBarFactory = new ControlProgressBarFactory();
export default controlProgressBarFactory;
